import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getFirstPermissionRoute } from '../../utils/roleUtils';
import { APP_TITLE } from '../../config/appBranding';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { login, user } = useAuth();
  const [dailyMessage, setDailyMessage] = useState('企业统一办公平台');

  useEffect(() => {
    if (user) {
      navigate(getFirstPermissionRoute(user));
    }
  }, [user, navigate]);

  useEffect(() => {
    const day = new Date().getDay();
    const messages = {
      1: '周一新起点，协同更高效',
      2: '周二稳推进，流程更规范',
      3: '周三过半场，审批更及时',
      4: '周四查遗漏，协作更顺畅',
      5: '周五善收尾，周末更安心',
      6: '周六做复盘，经验有沉淀',
      0: '周日养精神，下周更顺心'
    };
    setDailyMessage(messages[day] || '企业统一办公平台');
  }, []);

  const onFinish = async (values) => {
    await login(values.login, values.password);
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-brand">
          <h1 className="brand-title">{APP_TITLE}</h1>
          <p className="brand-subtitle">{dailyMessage}</p>
        </div>
        <div className="login-decorations">
          <div className="decoration-shape shape-1" />
          <div className="decoration-shape shape-2" />
          <div className="decoration-shape shape-3" />
        </div>
      </div>
      <div className="login-right">
        <Card className="login-card" bordered={false}>
          <div className="login-card-title">统一身份登录</div>
          <Form layout="vertical" size="large" onFinish={onFinish} autoComplete="off">
            <Form.Item
              name="login"
              label="账号 / 手机号"
              rules={[{ required: true, message: '请输入账号或手机号' }]}
            >
              <Input prefix={<UserOutlined />} placeholder="请输入账号或手机号" />
            </Form.Item>
            <Form.Item
              name="password"
              label="密码"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password prefix={<LockOutlined />} placeholder="请输入密码" />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
              <Button type="primary" htmlType="submit" block className="login-button">
                登录
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
